/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'spa': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M13.49 7.63A11.792 11.792 0 0 0 10.06 0a12.188 12.188 0 0 0-3.55 7.63A13.868 13.868 0 0 1 10 10.26a14.359 14.359 0 0 1 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM10 13.45A11.946 11.946 0 0 0 0 8a12.174 12.174 0 0 0 8.03 11.49A10.747 10.747 0 0 0 10 20a12.939 12.939 0 0 0 1.97-.51A12.174 12.174 0 0 0 20 8a11.946 11.946 0 0 0-10 5.45z" fill-rule="evenodd"/>'
  }
})
